function noop() {}
noop._name = 'react_rating_noop';

export default noop;



// WEBPACK FOOTER //
// ./src/utils/noop.js